import React, {useEffect, useState} from 'react';
import {getAllApprovedJobs, getAllJobFees} from '../../../../Store/Actions';
import ApprovedJobListing from '../../../../Components/UserComponents/Jobs/ApprovedJobListing';
import {useDispatch, useSelector} from 'react-redux';
import {createSelectionOptionsUtil} from '../../../../Util/commonUtility';

const ApprovedJobsContainer = () => {
  const {getApprovedJobs} = useSelector(({jobs}) => jobs);
  const [allApprovedJobsData, setAllApprovedJobsData] = useState([]);
  const [allSearchLocation, setAllSearchLocation] = useState([]);
  const {allJobFees} = useSelector(({jobFees}) => jobFees);
  const [jobFeesOptions, setJobFeesOptions] = useState([]);
  const [zeroFeeData, setZeroFeeData] = useState([]);
  let dispatch = useDispatch();

  useEffect(() => {
    const Data = getApprovedJobs?.data?.jobs;
    if (getApprovedJobs) {
      setAllApprovedJobsData(Data);
      const names = Data.map((item) => {
        return {label: item.location, value: item.location};
      });

      const removeDuplicates = (array) => {
        const uniqueItems = new Set(array.map((item) => JSON.stringify(item)));
        return Array.from(uniqueItems).map((item) => JSON.parse(item));
      };

      const filteredLoction = removeDuplicates(names);

      setAllSearchLocation([
        {value: '', label: 'Clear Filter'},
        ...filteredLoction,
      ]);
    } else {
      dispatch(getAllApprovedJobs());
    }
  }, [getApprovedJobs]);

  useEffect(() => {
    if (allJobFees) {
      setJobFeesOptions(
        createSelectionOptionsUtil(
          allJobFees?.data?.jobFees,
          'id',
          'details',
          'fee',
        ),
      );
      setZeroFeeData(
        allJobFees?.data?.jobFees?.filter((obj) => obj?.fee === 0),
      );
    } else {
      dispatch(
        getAllJobFees(
          {
            page: 1,
            pagecount: 100,
          },
          '',
          '',
          '',
        ),
      );
    }
  }, [allJobFees]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  return (
    <div>
      <ApprovedJobListing
        locationOptionsList={allSearchLocation}
        allApprovedJobsData={allApprovedJobsData}
        jobFeesOptions={jobFeesOptions}
        zeroFeeData={zeroFeeData}
      />
    </div>
  );
};

export default ApprovedJobsContainer;
